import type { Language } from '../types/lead'

/**
 * Formats a number as USD for DISPLAY ONLY, inside the estimator the visitor drives.
 * No price, payment, rate, or term is ever advertised by the page itself.
 */
export function formatCurrency(value: number, lang: Language): string {
  return new Intl.NumberFormat(lang === 'es' ? 'es-US' : 'en-US', {
    style: 'currency',
    currency: 'USD',
    maximumFractionDigits: 0,
  }).format(Math.round(value))
}

/** Parses a free-typed money field, tolerating commas, spaces, and a leading $. */
export function parseAmount(input: string): number {
  const cleaned = input.replace(/[^0-9.]/g, '')
  const value = Number.parseFloat(cleaned)
  return Number.isFinite(value) && value > 0 ? value : 0
}
